import {richMessagePlainText} from "../diagnostics/RichMessageText";
import type {MessageFact, MessageToken} from "../diagnostics/types";
import type {DecisionGraphModel, DecisionGraphNode} from "./decision-graph-model";

/** Results first, then everything else in the order it was recorded. */
export const orderDecisionSteps = (model: DecisionGraphModel, outputsFirst = true): DecisionGraphNode[] => outputsFirst
  ? [...model.nodes.filter(node => node.kind === "output"), ...model.nodes.filter(node => node.kind !== "output")]
  : model.nodes;

export const decisionTokenText = (token?: MessageToken) => `${token?.display ?? ""}${token?.unit ? ` ${token.unit}` : ""}`;

export const decisionFactText = (fact: MessageFact) => fact.label ? `${fact.label}: ${decisionTokenText(fact.value)}` : decisionTokenText(fact.value);

const INDENT = "    ";

/** The steps as indented plain text, for pasting into a ticket or email. */
export const decisionStepsToText = (model: DecisionGraphModel, {title, outputsFirst = true}: {title?: string; outputsFirst?: boolean} = {}) => {
  const out: string[] = title ? [title, ""] : [];
  orderDecisionSteps(model, outputsFirst).forEach((node, index) => {
    if (index > 0) out.push("");
    out.push(node.title);
    if (!node.messages?.length) {
      node.lines.forEach(line => out.push(INDENT + line));
      return;
    }
    node.messages.forEach(message => {
      const heading = richMessagePlainText(message);
      if (heading) out.push(INDENT + heading);
      (message.facts ?? []).forEach(fact => out.push((heading ? INDENT + INDENT : INDENT) + decisionFactText(fact)));
    });
  });
  return out.join("\n");
};
